// eslint-disable-next-line import/prefer-default-export
export const MODULE_FIELD_TYPES = {
  TEXT: {
    code_key: 'module_field_type_textfield'
  },
  TEXT_AREA: {
    code_key: 'module_field_type_textarea'
  },
  INTEGER: {
    code_key: 'module_field_type_integer',
  },
  ENCRYPTED: {
    code_key: 'module_field_type_encrypted',
  },
  BOOLEAN: {
    code_key: 'module_field_type_boolean',
  },
  DATETIME: {
    code_key: 'module_field_type_datetime',
  },
  DATE: {
    code_key: 'module_field_type_date',
  },
  TIME: {
    code_key: 'module_field_type_time',
  },
  DROPDOWN_SEARCHABLE: {
    code_key: 'module_field_type_dropdown_searchable',
  },
  DROPDOWN_SYSTEM: {
    code_key: 'module_field_type_dropdown_system',
  },
  DROPDOWN: {
    code_key: 'module_field_type_dropdown',
  },
  TAG_CLOUD: {
    code_key: 'module_field_type_tag_cloud',
  },
  SUBHEADER: {
    code_key: 'module_field_type_subheader',
  },
  SHOWMORE: {
    code_key: 'module_field_type_showmore',
  },
  CURRENCY: {
    code_key: 'module_field_type_currency',
  },
  HTML: {
    code_key: 'module_field_type_html',
  },
  EMAIL: {
    code_key: 'module_field_type_email',
  },
  EMAIL_WITH_NAME: {
    code_key: 'module_field_type_email_with_name',
  },
  URL: {
    code_key: 'module_field_type_url',
  },
  SPECIAL_INSTRUCTIONS: {
    code_key: 'module_field_type_special_instructions',
  },
  PERCENT: {
    code_key: 'module_field_type_percent',
  },
  S3_LINK: {
    code_key: 'module_field_type_s3_link',
  },
}
